// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lppo","question":"styles_question__1ItLb","description":"styles_description__14SPM"};